import styled from "styled-components";

export const ContainerCriarEndereco = styled.div`
  position: relative;

  div span {
    position: absolute;
    top: 16px;
    left: 16px;
  }
`;
